/* import __COLOCATED_TEMPLATE__ from './phone-field.hbs'; */
import Component from '@glimmer/component';
import styles from './phone-field.module.scss';

export default class ContactInformationPhoneField extends Component {
  styles = styles;
}
